<template>
    <i class="fa fa-building" :style="{opacity: ad.agency_commission ? 1 : 0.2}" v-tooltip="tooltip"></i>
</template>

<script>
    export default {
        props: {
            ad: {
                type: Object,
                required: true
            }
        },

        computed: {
            tooltip() {
                if(this.ad.agency_commission) {
                    return 'Agency Commission: ' + this.$options.filters.price(this.ad.agency_commission)
                }
            }
        }
    }
</script>
